(function () {
  var scrollToReviews = function () {
    var reviews = document.querySelector(".junup-product-review-wrapper .junip-product-review");
    const yOffset = -100;
    const y = reviews.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  };
  var reviewsWrapper = document.querySelector(".junip-wrapper");
  if (reviewsWrapper) {
    reviewsWrapper.addEventListener("click", scrollToReviews, false);
    reviewsWrapper.addEventListener("touchend", scrollToReviews, false);
  }
})();

// recharge widget editing
(function () {

  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  if ($(window).width() < 480) {
    $('.people_love_them .slider_mobile_only').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "draggable": true,
      "prevNextButtons": false,
      "wrapAround": true,
      "pageDots": true,
      "contain": true,
      "freeScroll": false,
      "initialIndex": 0
    });
  }
})();


// Junip anchor filtering
// example: 
// https://theearthlingco.com/products/shampoo-bars?filter_sort=most helpful&filter_hairtype=wavy_fine_flatter_s_shape&filter_hairconcern=frizz&filter_rating=5&filter_media=true
// ?filter_sort=mostHelpful&filter_hairtype=Wavy%20(Fine/Flatter%20S-Shape)&filter_concern=frizz&filter_rating=4
// ?filter_sort=mostHelpful&filter_hairtype=Wavy%20(Fine/Flatter%20S-Shape)&filter_hairconcern=frizz&filter_rating=4

(function () {
  document.addEventListener("junip-app-loaded", function () {
    let junipFiltersSort = document.querySelector('#junipReviewSort');
    let junipFiltersHairType = document.querySelector('#junipAttribute-560');
    let junipFiltersHairConcern = document.querySelector('#junipAttribute-561');
    let junipFiltersSkinType = document.querySelector('#junipAttribute-1071');
    let junipFiltersSkinConcern = document.querySelector('#junipAttribute-1070');
    let junipFiltersRating = document.querySelector('#junipRatingFilter');
    let junipFiltersMedia = document.querySelector('.junip-checkbox input');

    var params = (function (a) {
      if (a == "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
          b[p[0]] = "";
        else
          b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
      return b;
    })(window.location.search.substr(1).split('&'));

    let applyFilter = function (targetSelect, value) {
      setTimeout(function () {
        targetSelect.value = value;
        targetSelect.dispatchEvent(new Event('change', { 'bubbles': true }))
      }, 200);
    }

    Object.entries(params).forEach(([key, value]) => {
      if (key.includes('filter')) {
        console.log(`${key}: ${value}`);
        if (key.includes('sort')) {
          applyFilter(junipFiltersSort, value)
        } else if (key.includes('hairtype')) {
          applyFilter(junipFiltersHairType, value)
        } else if (key.includes('hairconcern')) {
          applyFilter(junipFiltersHairConcern, value)
        } else if (key.includes('skinconcern')) {
          applyFilter(junipFiltersSkinConcern, value)
        } else if (key.includes('skintype')) {
          applyFilter(junipFiltersSkinType, value)
        } else if (key.includes('rating')) {
          applyFilter(junipFiltersRating, value)
        } else if (key.includes('media')) {
          applyFilter(junipFiltersMedia, value)
        }
      }
    });
  });
})();


// Bar Types functionality
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // If on mobile, scroll active pill into view
    if (window.innerWidth <= 768) {
      const activePill = document.querySelector('.bar-type-pill.active');
      if (activePill) {
        setTimeout(() => {
          activePill.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }, 100);
      }
    }
  });
})();



// New accordion component fallback (<accordion-disclosure>)
;(function() {
  // Only define the new component; legacy accordions are handled elsewhere
  if (window.customElements && !window.customElements.get('accordion-disclosure')) {
    try {
      window.customElements.define('accordion-disclosure', class extends HTMLElement {
        connectedCallback(){
          if (this._igAccordionInitialized) {
            // Avoid rebinding listeners on reconnects
            return;
          }
          this._igAccordionInitialized = true;
          
          var details = this.querySelector('details');
          var summary = details && details.querySelector('summary');
          var content = details && details.querySelector('.ig-accordion__content, .accordion__content');
          if (!details || !summary || !content) return;

          function setAria(open){ details.setAttribute('aria-expanded', open ? 'true' : 'false'); }

          function openAccordion(){
            if (!details.hasAttribute('open')) details.setAttribute('open','');
            setAria(true);
            details._igClosing = false;
            // Measure final height and animate to it, then release height to avoid clipping
            var h = (content.firstElementChild || content).scrollHeight;
            content.style.maxHeight = h + 'px';
            content.style.opacity = '1';
            var released = false;
            var release = function(){
              if (released) return;
              released = true;
              content.removeEventListener('transitionend', onOpened);
              if (clearReleaseTimer) clearTimeout(clearReleaseTimer);
              if (details.hasAttribute('open') && !details._igClosing) {
                // Allow dynamic inner growth (nested accordions expanding) after animation completes
                content.style.maxHeight = 'none';
              }
            };
            var onOpened = function(e){
              // Ignore bubbled events from nested accordions and non-max-height transitions
              if (e.target !== content) return;
              if (e.propertyName !== 'max-height') return;
              release();
            };
            content.addEventListener('transitionend', onOpened);
            // Belt-and-braces: transitionend can be missed if the transition is interrupted
            // or if bubbling from nested accordions consumes the listener. Release on a timer too.
            var clearReleaseTimer = setTimeout(release, 450);
          }

          function closeAccordion(){
            // Reflect intent to close immediately for faster icon change
            setAria(false);
            // Mark as closing so subsequent taps see it as closed even before the attribute flips
            details._igClosing = true;
            // If height was released to 'none', fix it to current height before collapsing
            if (content.style.maxHeight === '' || content.style.maxHeight === 'none') {
              var fixH = (content.firstElementChild || content).scrollHeight;
              content.style.maxHeight = fixH + 'px';
              // force reflow so the browser acknowledges the fixed height before transition
              void content.offsetHeight;
            }
            var h = (content.firstElementChild || content).scrollHeight;
            content.style.maxHeight = h + 'px';
            content.style.opacity = '1';
            requestAnimationFrame(function(){
              content.style.maxHeight = '0px';
              content.style.opacity = '0';
            });
            var closed = false;
            var finalize = function(){
              if (closed) return;
              closed = true;
              content.removeEventListener('transitionend', done);
              if (closeTimer) clearTimeout(closeTimer);
              details.removeAttribute('open');
              details._igClosing = false;
            };
            var done = function(e){
              if (e.target !== content) return;
              if (e.propertyName !== 'max-height') return;
              finalize();
            };
            content.addEventListener('transitionend', done);
            var closeTimer = setTimeout(finalize, 450);
          }

          // Intercept click/keyboard to animate close smoothly
          var _lastToggleAt = 0;
          function shouldThrottleToggle(){
            var now = Date.now();
            if (now - _lastToggleAt < 250) return true;
            _lastToggleAt = now;
            return false;
          }
          summary.addEventListener('click', function(ev){
            ev.preventDefault();
            if (shouldThrottleToggle()) {
              
              return;
            }
            var isOpen = details.hasAttribute('open') && !details._igClosing;
            
            if (isOpen) { closeAccordion(); } else { openAccordion(); }
          });
          summary.addEventListener('keydown', function(ev){
            // Let the native synthesized click handle the toggle to avoid double toggles.
            // Prevent scrolling on Space, and optionally on Enter for consistency across browsers.
            if (ev.key === ' ' || ev.key === 'Spacebar') ev.preventDefault();
            if (ev.key === 'Enter') {
              // Do not toggle here; a click will follow.
            }
          });

          // Optional: If programmatically toggled elsewhere, you can sync by dispatching a custom event

          // Initial state
          setTimeout(function(){
            if (details.hasAttribute('open')) openAccordion();
            else { setAria(false); content.style.maxHeight = '0px'; content.style.opacity = '0'; }
          },0);
        }
      });
    } catch(e) {}
  }
})();

// Global helper functions for accessible strike-down pricing
// These must be in global scope to be accessible from all IIFEs
function createAccessibleStrikePrice(moneyText){
  // Returns HTML string with proper structure: <span aria-label="Original price"><span class="money">$XX.XX</span></span>
  return '<span aria-label="Original price"><span class="money">' + 
         String(moneyText).replace(/</g, '&lt;').replace(/>/g, '&gt;') + 
         '</span></span>';
}

function updateAccessibleStrikePrice(element, priceText, shouldShow){
  if (!element) return;
  
  if (shouldShow && priceText) {
    // Ensure proper structure exists
    var wrapper = element.querySelector('span[aria-label="Original price"]');
    if (!wrapper) {
      // Create the full structure if it doesn't exist
      element.innerHTML = createAccessibleStrikePrice(priceText);
    } else {
      // Update only the money text, preserving structure
      var moneyEl = wrapper.querySelector('.money');
      if (moneyEl) {
        moneyEl.textContent = priceText;
      } else {
        // Fallback: recreate structure
        element.innerHTML = createAccessibleStrikePrice(priceText);
      }
    }
    element.style.visibility = '';
    element.classList.remove('hidden');
    element.removeAttribute('aria-hidden');
  } else {
    element.style.visibility = 'hidden';
    element.classList.add('hidden');
    element.setAttribute('aria-hidden', 'true');
  }
}

// Subscription selector (moved from snippet)
(function(){
  // Template detection (kept for future logic if needed)
  var IS_SUBONLY = false;
  try { IS_SUBONLY = (window._template && /subonly/i.test(String(window._template.suffix||''))) || (document.body && /SubOnly/i.test(String(document.body.className||''))); } catch(e) {}
  var MONEY_FORMAT = (function(){
    try { return (document.body && document.body.getAttribute('data-money-format')) || "${{amount}}"; } catch(e) { return "${{amount}}"; }
  })();

  function formatMoneyFromCents(cents){
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, MONEY_FORMAT);
      }
    } catch(e) {}
    var dollars = (Number(cents || 0) / 100).toFixed(2);
    return '$' + dollars;
  }

  function initSubscriptionSelector(root){
    if (!root || root._tecSubSelInitialized) return;
    root._tecSubSelInitialized = true;

    var select = root.querySelector('.subscription-selector__select');
    if (!select) return;
    var variantInput = document.querySelector('input[name="id"].sellingPlanVarID') || document.querySelector('input[name="id"]');
    var hiddenPlanInput = document.querySelector('input[name="selling_plan"]');
    var mapScript = root.querySelector('script[data-variant-plan-map]');
    var pricingScript = root.querySelector('script[data-variant-pricing-map]');
    var variantPlanMap = {}; var pricingMap = {};
    try { variantPlanMap = JSON.parse(mapScript && mapScript.textContent || '{}'); } catch(e) { variantPlanMap = {}; }
    try { pricingMap = JSON.parse(pricingScript && pricingScript.textContent || '{}'); } catch(e) { pricingMap = {}; }
    var requiresPlan = root.getAttribute('data-requires-plan') === 'true';

    // Cache frequently-used nodes
    var cta = document.querySelector('.purchase-details__buttons [type="submit"].add_to_cart');
    var ctaLabelSpan = cta && (cta.querySelector('.text .original_label') || cta.querySelector('.text'));
    if (ctaLabelSpan && ctaLabelSpan.hasAttribute('data-static-cta')) ctaLabelSpan = null;
    var ctaPrefix = cta ? (cta.getAttribute('data-label') || 'Add to cart') : '';
    // Tag once and cache collections
    try {
      document.querySelectorAll('.modal_price .current_price').forEach(function(el){ el.classList.add('tec-current-price'); });
      document.querySelectorAll('.modal_price .was_price').forEach(function(el){ el.classList.add('tec-compare-price'); });
      document.querySelectorAll('.title_rating_price .current_price').forEach(function(el){ el.classList.add('tec-current-price'); });
      document.querySelectorAll('.title_rating_price .was_price').forEach(function(el){ el.classList.add('tec-compare-price'); });
    } catch(e) {}
    var currentPriceEls = document.querySelectorAll('.tec-current-price, .modal_price .current_price, .title_rating_price .current_price');
    var wasPriceEls = document.querySelectorAll('.tec-compare-price, .modal_price .was_price, .title_rating_price .was_price');

    // Internal render state for no-op skips
    var lastState = { variantId: null, isSub: null, price: null, compare: null, qty: 1 };

    function getCurrentVariantId(){
      var val = variantInput && (variantInput.value || variantInput.getAttribute('value'));
      return val ? String(val) : null;
    }

    function syncHidden(){ if (hiddenPlanInput) hiddenPlanInput.value = select.value || ''; }

    function updatePrices(){
      var variantId = getCurrentVariantId();
      if (!variantId) return;
      var data = pricingMap[String(variantId)] || {};
      var isSub = !!select.value;
      var mainPriceCents = isSub ? (data.subscription_price || data.price || 0) : (data.price || 0);
      // Use compare_at_price when available for both subscription and one-time purchases
      // If subscription and one-time are the same price, compare_at_price should be used for both
      var compareCents = (data.compare_at_price != null && data.compare_at_price > 0) 
        ? data.compare_at_price 
        : null;

      // Determine selected quantity (default to 1) before deciding to skip
      var qtyInputForSkip = document.querySelector('#quantity, [name="quantity"]');
      var qtyForSkip = 1;
      try { qtyForSkip = Math.max(1, parseInt(qtyInputForSkip && (qtyInputForSkip.value || qtyInputForSkip.getAttribute('value')) || '1')); } catch(e) { qtyForSkip = 1; }

      // Read volume discount for skip check
      var volWidgetForSkip = document.querySelector('.volume-widget[data-active-discount]');
      var volDiscForSkip = volWidgetForSkip ? (parseInt(volWidgetForSkip.getAttribute('data-active-discount'), 10) || 0) : 0;

      // Skip DOM work if nothing relevant changed (variant, sub state, unit prices, quantity, or volume discount)
      if (lastState.variantId === variantId && lastState.isSub === isSub && lastState.price === mainPriceCents && lastState.compare === compareCents && lastState.qty === qtyForSkip && lastState.volDisc === volDiscForSkip) {
        return;
      }
      lastState.variantId = variantId; lastState.isSub = isSub; lastState.price = mainPriceCents; lastState.compare = compareCents; lastState.qty = qtyForSkip; lastState.volDisc = volDiscForSkip;

      // Batch DOM writes
      requestAnimationFrame(function(){
        // Compute totals for main price using selected quantity; apply volume discount if active
        var qty = lastState.qty || 1;
        var volumeWidget = document.querySelector('.volume-widget[data-active-discount]');
        var volumeDiscount = volumeWidget ? (parseInt(volumeWidget.getAttribute('data-active-discount'), 10) || 0) : 0;
        // Volume tiers come off each unit, rounded down to the cent, as checkout does
        var unitMainCents = Number(mainPriceCents) || 0;
        var displayMainCents = qty * (unitMainCents - Math.floor(unitMainCents * volumeDiscount / 100));
        var displayCompareCents = (compareCents != null) ? Number(compareCents) : null;

        var activeCTAPrefix = isSub ? 'Subscribe & Save' : ctaPrefix;
        if (ctaLabelSpan) ctaLabelSpan.textContent = activeCTAPrefix + ' - ' + formatMoneyFromCents(displayMainCents);
        currentPriceEls.forEach(function(el){
          var txt = formatMoneyFromCents(displayMainCents);
          var money = el.querySelector('.money') || el;
          if (money.textContent !== txt) money.textContent = txt;
          try { money.setAttribute('aria-label', (lastState.isSub ? 'Discounted price' : 'Price')); } catch(e) {}
        });
        wasPriceEls.forEach(function(el){
          if (displayCompareCents != null && displayCompareCents > mainPriceCents) {
            var txt = formatMoneyFromCents(displayCompareCents);
            updateAccessibleStrikePrice(el, txt, true);
          } else {
            updateAccessibleStrikePrice(el, null, false);
          }
        });
      });
    }

    function filterOptionsForVariant(variantId){
      var allowed = (variantId && variantPlanMap[String(variantId)]) ? variantPlanMap[String(variantId)] : [];
      var hadSelection = false;
      Array.prototype.forEach.call(select.options, function(opt){
        if (opt.value === '') { opt.disabled = requiresPlan; opt.hidden = requiresPlan; return; }
        var enabled = allowed.indexOf(String(opt.value)) !== -1;
        opt.disabled = !enabled;
        opt.hidden = !enabled;
        if (enabled && !hadSelection && requiresPlan) {
          select.value = opt.value; hadSelection = true;
        }
      });
      var currentValue = select.value;
      var hasAnyAllowed = Array.isArray(allowed) && allowed.length > 0;
      if (!hasAnyAllowed || (currentValue && allowed.indexOf(String(currentValue)) === -1)) {
        select.value = '';
      }
      syncHidden();
      updatePrices();
    }

    select.addEventListener('change', function(){ syncHidden(); updatePrices(); });

    // Keep pricing in sync with quantity changes
    try {
      var quantityInput = document.querySelector('#quantity, [name="quantity"]');
      if (quantityInput) {
        var onQtyChange = function(){ updatePrices(); };
        quantityInput.addEventListener('input', onQtyChange, { passive: true });
        quantityInput.addEventListener('change', onQtyChange, { passive: true });
      }
      if (!window._tecQtyListenersBound) {
        document.addEventListener('click', function(e){
          try {
            if (e && e.target && e.target.closest && e.target.closest('.js-change-quantity')) {
              setTimeout(updatePrices, 50);
            }
          } catch(err) {}
        }, { passive: true });
        window._tecQtyListenersBound = true;
      }
    } catch(e) {}

    // Observe variant id changes (attribute) and listen to change events for themes that dispatch them
    try {
      var observer = new MutationObserver(function(){ filterOptionsForVariant(getCurrentVariantId()); });
      if (variantInput) observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    } catch(e) {}
    if (variantInput) variantInput.addEventListener('change', function(){ filterOptionsForVariant(getCurrentVariantId()); }, { passive: true });

    filterOptionsForVariant(getCurrentVariantId());
    updatePrices();
  }

  function initAll(){
    document.querySelectorAll('.subscription-selector').forEach(initSubscriptionSelector);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();


// Mini subscription widget: checkbox toggles one-time vs subscription
(function(){
  function initMini(root){
    if (!root || root._tecMiniInitialized) return; root._tecMiniInitialized = true;
    var checkbox = root.querySelector('#ab_auto_refills');
    var select = document.querySelector('.subscription-selector__select');
    var hiddenPlanInput = document.querySelector('input[name="selling_plan"]');
    var pricingCurrent = root.querySelector('.ab-test-price');
    var pricingOriginal = root.querySelector('.ab-test-price-original');
    var wrapper = root.querySelector('.ab-test-checkbox-wrapper');
    var toggleContainer = root.querySelector('.ab-test-subscription-toggle');

    function getVariantId(){
      var v = document.querySelector('input[name="id"].sellingPlanVarID') || document.querySelector('input[name="id"]');
      return v && (v.value || v.getAttribute('value'));
    }

    function format(c){
      try { return window.Shopify.formatMoney(c, (document.body && document.body.getAttribute('data-money-format')) || "${{amount}}" ); } catch(e) {}
      return '$' + (Number(c||0)/100).toFixed(2);
    }

    function setDisabledState(disabled){
      if (!checkbox) return;
      checkbox.disabled = !!disabled;
      if (wrapper) {
        if (disabled) { wrapper.classList.add('is-disabled'); wrapper.setAttribute('aria-disabled','true'); }
        else { wrapper.classList.remove('is-disabled'); wrapper.removeAttribute('aria-disabled'); }
      }
      if (toggleContainer) {
        if (disabled) toggleContainer.classList.add('is-disabled');
        else toggleContainer.classList.remove('is-disabled');
      }
    }

    function recalcPrices(){
      // Reuse pricing map co-located with subscription selector near this product form
      var selectorRoot = document.querySelector('.subscription-selector[data-product-id]');
      var pricingScript = selectorRoot && selectorRoot.querySelector('script[data-variant-pricing-map]');
      var planScript = selectorRoot && selectorRoot.querySelector('script[data-variant-plan-map]');
      var pricingMap = {}; var planMap = {};
      try { pricingMap = JSON.parse(pricingScript && pricingScript.textContent || '{}'); } catch(e) { pricingMap = {}; }
      try { planMap = JSON.parse(planScript && planScript.textContent || '{}'); } catch(e) { planMap = {}; }
      var vid = String(getVariantId()||'');
      var data = pricingMap[vid] || {};
      var allowed = planMap[vid] || [];
      var useSub = !!(checkbox && checkbox.checked) && !!(select && select.options && select.options.length && select.value);
      if (!allowed || allowed.length === 0) {
        // No plans available: force unchecked, clear selection, disable UI
        if (checkbox && checkbox.checked) checkbox.checked = false;
        if (select && select.value) {
          select.value = '';
          if (hiddenPlanInput) hiddenPlanInput.value = '';
          try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch(e) {}
        }
        useSub = false;
        setDisabledState(true);
      } else {
        // Plans available: enable UI
        setDisabledState(false);
      }
      var price = useSub ? (data.subscription_price || data.price || 0) : (data.price || 0);
      // Use compare_at_price when available for both subscription and one-time purchases
      var compare = (data.compare_at_price != null && data.compare_at_price > 0) 
        ? data.compare_at_price 
        : null;
      if (pricingCurrent) {
        pricingCurrent.textContent = format(price);
        try { pricingCurrent.setAttribute('aria-label', useSub ? 'Discounted price' : 'Price'); } catch(e) {}
      }
      if (pricingOriginal) {
        if (compare != null && compare > price) {
          var formattedPrice = format(compare);
          updateAccessibleStrikePrice(pricingOriginal, formattedPrice, true);
        } else {
          updateAccessibleStrikePrice(pricingOriginal, null, false);
        }
      }
    }

    function applyToggle(){
      if (!select) return;
      if (checkbox && checkbox.checked) {
        // choose first non-empty option (subscription) if available
        var sub = Array.prototype.find.call(select.options, function(o){ return o.value !== '' && !o.disabled && !o.hidden; });
        if (sub) select.value = sub.value;
      } else {
        select.value = '';
      }
      if (hiddenPlanInput) hiddenPlanInput.value = select.value || '';
      // Trigger main pricing updater by changing the select
      try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch(e) {}
      recalcPrices();
    }

    if (checkbox) checkbox.addEventListener('change', applyToggle, { passive: true });
    // Keep in sync with variant changes
    var varInput = document.querySelector('input[name="id"].sellingPlanVarID') || document.querySelector('input[name="id"]');
    if (varInput) {
      varInput.addEventListener('change', recalcPrices, { passive: true });
      try { var mo = new MutationObserver(function(){ recalcPrices(); }); mo.observe(varInput, { attributes: true, attributeFilter: ['value'] }); } catch(e) {}
    }
    if (select) select.addEventListener('change', function(){ var isSub = !!select.value; if (checkbox) checkbox.checked = isSub; recalcPrices(); }, { passive: true });
    recalcPrices();
    // On initial load, if checkbox is pre-checked, ensure select is set and trigger change to update main page prices
    if (checkbox && checkbox.checked) {
      if (select && !select.value) {
        // If checkbox is checked but select has no value, set it to first available subscription option
        var sub = Array.prototype.find.call(select.options, function(o){ return o.value !== '' && !o.disabled && !o.hidden; });
        if (sub) {
          select.value = sub.value;
          if (hiddenPlanInput) hiddenPlanInput.value = sub.value;
        }
      }
      // Trigger select change event to update main page prices via initSubscriptionSelector's updatePrices()
      if (select && select.value) {
        setTimeout(function(){
          try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch(e) {}
        }, 50);
      }
    }
  }

  function initAllMini(){ document.querySelectorAll('#tec-mini-widget, #ab-test-purchase-widget').forEach(initMini); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllMini);
  else initAllMini();
})();

// Native Volume Discount Widget (soap-bars only)
(function() {
  if (!document.body.classList.contains('soap-bars')) return;

  var TIERS = [
    { qty: 1, label: '1 bar', discount: 0 },
    { qty: 2, label: '2 bars', discount: 15 },
    { qty: 3, label: '3 bars', discount: 25 }
  ];

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, '${{amount}}'); } catch(e) {}
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function getUnitPrices() {
    var oneTimeCents = 0;
    var subscriptionCents = 0;
    try {
      var root = document.querySelector('.subscription-selector[data-product-id]');
      var script = root && root.querySelector('script[data-variant-pricing-map]');
      var map = JSON.parse((script && script.textContent) || '{}');
      var vInput = document.querySelector('input[name="id"].sellingPlanVarID') || document.querySelector('input[name="id"]');
      var vId = vInput && (vInput.value || vInput.getAttribute('value'));
      var data = (vId && map[String(vId)]) || {};
      oneTimeCents = Number(data.price || 0);
      subscriptionCents = Number(data.subscription_price || 0);
    } catch(e) {}
    if (!subscriptionCents && oneTimeCents) {
      subscriptionCents = Math.round(oneTimeCents * 0.8);
    }
    return { oneTime: oneTimeCents || 0, subscription: subscriptionCents || 0 };
  }

  function isSubscriptionActive() {
    var cb = document.querySelector('#ab_auto_refills');
    return !!(cb && cb.checked);
  }

  function recalcPrices(widget) {
    var prices = getUnitPrices();
    var useSub = isSubscriptionActive();
    var unitCents = useSub ? (prices.subscription || prices.oneTime) : (prices.oneTime || prices.subscription);
    if (!unitCents) return;

    widget.querySelectorAll('.volume-widget__option').forEach(function(btn) {
      var qty = parseInt(btn.dataset.quantity, 10) || 1;
      var disc = parseInt(btn.dataset.discount, 10) || 0;
      var compareCents = unitCents * qty;
      // Checkout takes the discount off each unit and rounds it down to the cent
      var totalCents = qty * (unitCents - Math.floor(unitCents * disc / 100));

      var priceEl = btn.querySelector('.volume-widget__price');
      if (priceEl) priceEl.textContent = formatMoney(totalCents);

      var compareEl = btn.querySelector('.volume-widget__compare');
      if (disc > 0 && compareEl) {
        compareEl.innerHTML = '<s>' + formatMoney(compareCents) + '</s>';
      }
    });
  }

  function init() {
    var widget = document.querySelector('.volume-widget');
    if (!widget || widget._volumeInit) return;
    widget._volumeInit = true;

    var options = widget.querySelectorAll('.volume-widget__option');
    var quantityInput = document.querySelector('#quantity');

    // Set initial discount on widget
    widget.setAttribute('data-active-discount', '0');

    options.forEach(function(btn) {
      btn.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var qty = parseInt(btn.dataset.quantity, 10);
        var disc = parseInt(btn.dataset.discount, 10) || 0;
        widget.setAttribute('data-active-discount', disc);

        if (quantityInput) {
          quantityInput.value = qty;
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });

    // Recalculate on subscription toggle
    var refillCheckbox = document.querySelector('#ab_auto_refills');
    if (refillCheckbox) {
      refillCheckbox.addEventListener('change', function() {
        recalcPrices(widget);
      });
    }

    // Recalculate on variant change
    var variantInput = document.querySelector('input[name="id"].sellingPlanVarID') || document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', function() { recalcPrices(widget); });
      if (window.MutationObserver) {
        new MutationObserver(function() { recalcPrices(widget); })
          .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
